<template>
  <div class="common-table">
    <el-table :data="tableData" height="90%" :cell-style="{ padding: '5px 0' }" stripe highlight-current-row style="width: 100%" v-loading="config.loading">
      <el-table-column label="序号" width="85">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ (config.page - 1) * config.size + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip v-for="item in tableLabel" :key="item.prop" :label="item.label" :width="item.width ? item.width : 125">
        <template slot-scope="scope">
          <span style="margin-left: 0px">{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleDownload(scope.row)">下载</el-button>
          <!-- <el-button size="mini" type="primary" @click="contFiling(scope.row)">归档</el-button>
          <el-button size="mini" type="info" @click="backToLoms(scope.row)">回传运营</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      layout="prev, pager, next"
      :total="config.total"
      :current-page.sync="config.page"
      @current-change="changePage"
      :page-size="config.size"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Array,
    tableLabel: Array,
    config: Object
  },
  methods: {
    changePage(page) {
      this.$emit('changePage', page)
    },
    handleView(row) {
      this.$emit('view', row)
    },
    handleDownload(row) {
      this.$emit('download', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.common-table {
  height: 400px;
  background-color: #fff;
  position: relative;
  .pager {
    position: absolute;
    bottom: 0;
    right: 20px;
  }
}
</style>
